import { FileXIcon, TrashIcon } from "@phosphor-icons/react";

import { PageDataPlaceholder } from "@/shared/components/ui/PageDataPlaceholder";
import { FetchedNote } from "@/services/api/fetchers/notes";

interface NotesTrashPlaceholdersProps {
  deletedNotes: FetchedNote[] | null;
}

export function NotesTrashPlaceholders({ deletedNotes }: NotesTrashPlaceholdersProps) {
  if (!deletedNotes) {
    return <PageDataPlaceholder description="Something went wrong" icon={<FileXIcon />} title="Notes not found" />;
  }

  if (!deletedNotes.length) {
    return (
      <PageDataPlaceholder description="Deleted notes will appear here" icon={<TrashIcon />} title="Trash is empty" />
    );
  }

  return null;
}
